import React from 'react'
import { connect } from 'react-redux'
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride'

import './Tour.scss'

const options = {
  arrowColor: '#deb053',
  backgroundColor: '#deb053',
  beaconSize: 36,
  overlayColor: 'rgba(0, 0, 0, 0.5)',
  primaryColor: '#414142',
  spotlightShadow: '0 0 15px rgba(0, 0, 0, 0.75)',
  textColor: '#222',
  width: undefined,
  zIndex: 100,
}

const locale = {
  back: 'Back',
  close: 'Close',
  last: "Let's Play!",
  next: 'Next',
  skip: "Don't Show",
}

export class TourPreso extends React.Component {
  constructor(...args) {
    super(...args)

    let { steps, stepIndex } = this.props,
      controlled = steps.length && stepIndex === 0,
      startingState = {
        run: false,
        reset: false,
        steps: controlled ? [steps[0], ...steps] : steps,
        stepIndex: controlled ? stepIndex + 1 : this.props.stepIndex,
      }

    this.state = { ...startingState }

    this.callback = ({ action, index, status, type }) => {
      if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
        this.setState({
          reset: false,
          stepIndex: index + (action === ACTIONS.PREV ? -1 : 1),
        })
      } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
        window.scrollTo(0, 0)
        this.setState({ ...startingState })
      }

      if (status === STATUS.SKIPPED) {
        window.localStorage.setItem(`tour-${this.props.name}`, true)
      }
    }

    this.bootstrap = force => {
      let { name, reset } = this.props,
        startTour = () =>
          (this.timeout = setTimeout(() => this.setState({ run: true }), 500))

      force = force || this.props.force

      if (reset || force || !window.localStorage.getItem(`tour-${name}`))
        startTour(true)
    }
  }

  componentDidMount() {
    this.bootstrap()
  }

  componentDidUpdate() {
    if (this.state.reset) this.bootstrap(true)
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  static getDerivedStateFromProps(newProps, oldState) {
    return newProps.reset !== oldState.reset
      ? { ...oldState, reset: !!newProps.reset }
      : oldState
  }

  render() {
    let { steps, stepIndex } = this.props

    // there's a truthiness bug in Joyride that doesn't allow you start at 0,
    // so this is a hack to get around that
    if (steps.length && stepIndex === 0) {
      steps = [steps[0], ...steps]
      stepIndex = stepIndex + 1
    }

    return (
      <Joyride
        locale={locale}
        styles={{ options }}
        callback={this.callback}
        {...this.props}
        {...this.state}
      />
    )
  }
}

function mapStateToProps(_, op) {
  return { ...op }
}

export const Tour = connect(mapStateToProps)(TourPreso)
export default Tour

///////////////////////////////////////////////////////////////

export function VlpTour(props) {
  const steps = [
    {
      target: '.inventory-story-control-group',
      placement: 'bottom',
      title: 'Step #1',
      content: 'INVENTORY FILTER OPTIONS',
    },
    {
      target: '.quote-filters',
      placement: 'top',
      title: 'Step #2',
      content: 'SELECT DESIRED LOAN OPTIONS',
    },
    {
      target: '.vehicles-list',
      placement: 'top',
      title: 'Step #3',
      content: 'SELECT VEHICLE TO VIEW DETAILS',
    },
  ]

  return (
    <Tour
      {...props}
      steps={steps}
      stepIndex={0}
      continuous
      spotlightClicks
      showSkipButton
      name="vlp-tour"
    />
  )
}

export function SurveyTour(props) {
  const steps = [
    {
      target: '.pricing-survey',
      placement: 'top',
      title: 'Step #1',
      content: 'SELECT PAYMENT & TERMS',
    },
    {
      target: '.deal-addition-blocks',
      placement: 'top',
      title: 'Step #2',
      content: 'Tune Your Perfect Payment',
    },
  ]

  return (
    <Tour
      {...props}
      steps={steps}
      stepIndex={0}
      continuous
      spotlightClicks
      showSkipButton
      name="advanced-quote"
    />
  )
}
